export default "__VITE_ASSET__fbd9ed76__"